<div class="content_wrapper" id="skuIdsContent">
  <section class="sku_ids_sidenav">
    <div class="sku_ids_sidenav_header" id="skuIdSideNavHeader" i18n="@@app.top-nav.skus">SKUs</div>
    <div class="sku_ids_sidenav_item" id="skuIdSideNavItm">
      <div (click)="navigate('skuIdInfo')" [ngClass]="{'active': sideNavItem === 'skuIdInfo'}" id="skuIdInfo">
        <img [ngClass]="(sideNavItem === 'skuIdInfo') ? 'sku_id_info_active_icon' : 'sku_id_info_icon'"
          alt="SKU ID Info icon"><span i18n="@@sku-ids.label.sku-info-nav">SKU Info</span>
      </div>
      <div  *ngIf="!isSrtAdmin" (click)="navigate('uploadCSV')" [ngClass]="{'active': sideNavItem === 'uploadCSV'}" id="navigateUploadCSV">
        <img class="upload_csv_icon"
          [ngClass]="(sideNavItem === 'uploadCSV') ? 'upload_csv_active_icon' : 'upload_csv_icon'"
          alt="Upload CSV icon"><span i18n="@@sku-ids.label.upload-via-csv">Upload via CSV</span>
      </div>
      <div *ngIf="!isSrtAdmin" (click)="navigate('skuCompare')" [ngClass]="{'active': sideNavItem === 'skuCompare'}" id="navigateSkuCompare">
        <img class="sku_compare_icon"
          [ngClass]="(sideNavItem === 'skuCompare') ? 'sku_compare_active_icon' : 'sku_id_info_icon'"
          alt="SKU compare icon"><span i18n="@@sku-ids.label.sku-comparison-via-csv">SKU Comparison</span>
      </div>
      <div *ngIf="sideNavItem === 'skuIdInfo' && skuIdLength > 0" class="mt-5 data_footer" id="dwnldCsvFile">
        <button type="button" (click)="downloadCsvFile()" class="btn btn-outline-primary left_icon_btn download_btn gtmUsersStoresDownloadCSV">
          <span i18n="@@stores.store-user.download-csv">Download CSV</span>
        </button>
      </div>
    </div>
  </section>
  <section class="child_section" [ngClass]="{'rtl-margin': isArabic || isHebrew}">
    <ng-container *ngIf="sideNavItem === 'skuIdInfo'">
      <iposcen-sku-id-info  (skuIdLength)='skuIdLength = $event'></iposcen-sku-id-info>
    </ng-container>
    <ng-container *ngIf="sideNavItem === 'uploadCSV'">
      <iposcen-upload-sku-csv></iposcen-upload-sku-csv>
    </ng-container>
    <ng-container *ngIf="sideNavItem === 'skuCompare'">
      <iposcen-compare-sku-ids></iposcen-compare-sku-ids>
    </ng-container>
  </section>
</div>